module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "find-job section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "detail-job"
  }, [_c('div', {
    staticClass: "head-detail-job"
  }, [_c('div', {
    staticClass: "row col-md-12"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('h3', [_vm._v(_vm._s(_vm.itemOferta.oferta.titulo))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.itemOferta.empresa.nombre) + " - " + _vm._s(_vm.itemOferta.oferta.ubicacion.comuna))]), _vm._v(" "), _c('div', {
    staticClass: "row col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-calendar",
    staticStyle: {
      "margin-top": "15px",
      "color": "#999"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.formatoFecha(_vm.itemOferta.oferta.fecha)))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode == 1),
      expression: "mode==1"
    }],
    staticClass: "col-md-6"
  }, [_vm._m(0)])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode == 1),
      expression: "mode==1"
    }],
    staticClass: "col-md-3"
  }, [_vm._m(1)])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "body-detail-job"
  }, [_c('div', {
    staticClass: "contenido-card"
  }, [_c('h3', {
    staticClass: "margin-top"
  }, [_vm._v("Descripción")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "'Nunito Sans'"
    }
  }, [_vm._v(_vm._s(_vm.itemOferta.oferta.descripcion))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode == 1),
      expression: "mode==1"
    }]
  }, [_c('h4', {
    staticClass: "margin-top"
  }, [_vm._v("Requisitos")]), _vm._v(" "), _c('div', {
    staticClass: "label-contenido1"
  }, [_vm._v("ESTUDIOS : Formación Profesional grado medio")]), _vm._v(" "), _c('h4', {
    staticClass: "margin-top"
  }, [_vm._v("Datos complementarios")]), _vm._v(" "), _c('div', {
    staticClass: "label-contenido1"
  }, [_vm._v("SALARIO : $100.000")]), _vm._v(" "), _c('div', {
    staticClass: "label-contenido1"
  }, [_vm._v("JORNADA LABORAL: $100.000")]), _vm._v(" "), _c('div', {
    staticClass: "label-contenido1"
  }, [_vm._v("Cheque Restaurant")]), _vm._v(" "), _c('div', {
    staticClass: "label-contenido1"
  }, [_vm._v("Bonos")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode == 2),
      expression: "mode==2"
    }]
  }, [_c('br'), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ",
    on: {
      "click": _vm.homePage
    }
  }, [_vm._v(" Volver"), _vm._m(4)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-briefcase",
    staticStyle: {
      "margin-top": "15px",
      "color": "#999"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Full Time")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "facebookBtn smGlobalBtn",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "twitterBtn smGlobalBtn",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "linkedinBtn smGlobalBtn",
    attrs: {
      "href": "#"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-primary "
  }, [_vm._v(" Postular a la Vacante"), _c('div', {
    staticClass: "ripple-container"
  }, [_c('div', {
    staticClass: "ripple ripple-on ripple-out",
    staticStyle: {
      "left": "75.7188px",
      "top": "-1px",
      "background-color": "rgb(255, 255, 255)",
      "transform": "scale(3.34034)"
    }
  }), _c('div', {
    staticClass: "ripple ripple-on ripple-out",
    staticStyle: {
      "left": "53.5313px",
      "top": "4px",
      "background-color": "rgb(255, 255, 255)",
      "transform": "scale(2.97101)"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info"
  }, [_c('span', [_c('strong', {
    staticStyle: {
      "font-size": "20px",
      "margin-left": "5px",
      "vertical-align": "bottom"
    }
  }, [_vm._v("INFORMACIÓN")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("La postulación a esta oferta es vía correo electrónico.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ripple-container"
  }, [_c('div', {
    staticClass: "ripple ripple-on ripple-out",
    staticStyle: {
      "left": "75.7188px",
      "top": "-1px",
      "background-color": "rgb(255, 255, 255)",
      "transform": "scale(3.34034)"
    }
  }), _c('div', {
    staticClass: "ripple ripple-on ripple-out",
    staticStyle: {
      "left": "53.5313px",
      "top": "4px",
      "background-color": "rgb(255, 255, 255)",
      "transform": "scale(2.97101)"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25a654af"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/OfertaPostulacionView.vue
// module id = 638
// module chunks = 1